import { Injectable } from '@angular/core';
import { P } from 'src/app/config/portal-permissions.constants';
import { PermissionActionService } from 'src/app/core/permissions/permission-action.service';
import { PermissionService } from 'src/app/core/permissions/permission.service';

@Injectable({ providedIn: 'root' })
export class GorevPanosuPermissionService {
  readonly moduleKey = P.GorevPanosu.Module;
  readonly projeYonetimiKey = P.GorevPanosu.ProjeYonetimi;

  constructor(
    private permissionService: PermissionService,
    private permissionAction: PermissionActionService,
  ) {}

  canReadGorevPanosu(): boolean {
    return this.permissionService.hasRead(this.moduleKey);
  }

  canReadProjeYonetimi(): boolean {
    return this.permissionService.hasRead(this.projeYonetimiKey);
  }

  assertProjeYonetimiWrite(): boolean {
    return this.permissionAction.assertWrite(this.projeYonetimiKey);
  }
}
